import { useDispatch } from 'react-redux';
import Button from '../../../../components/Button';
import { t } from '../../../../lang';
import { appSlice } from '../../../../store/slices';
import { createRootModal } from '../../RootModal';
import './PaymentConfigurationInfo.scss';

const PaymentConfigurationInfo = createRootModal(() => {
	const dispatch = useDispatch();

	const closeModal = () => {
		dispatch(appSlice.actions.closeLastModal());
	};

	return (
		<div className='PaymentConfigurationInfo'>
			<div className='PaymentConfigurationInfo__Content'>
				<p>
					{t(
						'This is the fee paid to the blockchain to process your transaction. Transaction speed depends on the fee amount: higher fees are usually confirmed faster'
					)}
				</p>

				<div className='PaymentConfigurationInfo__Content__second'>
					<p className='PaymentConfigurationInfo__Content__second-bold'>{t('Use a single transaction for inputs')}</p>
					<p>
						{t(
							'All inputs will be combined into one transaction. This can lower the total fee but increases the chance that those addresses will be linked on the blockchain.'
						)}
					</p>
					<p>
						{t(
							'Note: combining inputs within a single transaction may result in visible linkage between addresses at the blockchain level. Consider this when choosing how inputs are processed.'
						)}
					</p>
				</div>
			</div>

			<div style={{ display: 'flex', justifyContent: 'center' }}>
				<Button styleType='secondary' className='PaymentConfigurationInfo__button' onClick={closeModal}>
					{t('Got it')}
				</Button>
			</div>
		</div>
	);
});

export default PaymentConfigurationInfo;
